// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_fit-cards.scss';


// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------

function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}


$(function() {
    
    // -------------------------------------
    // Fit Cards - Collection Page
    // -------------------------------------
    $(".carousel--collection-fit-cards").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each feature collection slider
        $this.addClass("collection-fit-cards-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.fit-cards').find(".swiper-button-prev").addClass("collection-fit-cards-btn-prev-" + index);
        $this.parents('.fit-cards').find(".swiper-button-next").addClass("collection-fit-cards-btn-next-" + index);

        // Generate unique btn classes for slider swiper
        $this.parents('.fit-cards').find(".swiper-scrollbar").addClass("collection-fit-cards-swiper-scrollbar-" + index);


        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".collection-fit-cards-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
            slidesPerView: 1.2,
            spaceBetween: 5,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            keyboard: {
                enabled: false
            },

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 2,
                    spaceBetween: 5
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 5
                }
            },

             // // Navigation arrows
            navigation: {
                nextEl: ".collection-fit-cards-btn-next-" + index,
                prevEl: ".collection-fit-cards-btn-prev-" + index
            },

            // // Navigation scrollbar
            scrollbar: {
                el: ".collection-fit-cards-swiper-scrollbar-" + index,
                draggable: true,
            }
        });
    });
    
    
    // -------------------------------------
    // Fit Cards - PDP Range
    // -------------------------------------
    $(".carousel--pdp-fit-cards").each(function(index, element) {
        var $this = $(this);

        // Generate unique class for each feature collection slider
        $this.addClass("pdp-fit-cards-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.fit-cards').find(".swiper-button-prev").addClass("pdp-fit-cards-btn-prev-" + index);
        $this.parents('.fit-cards').find(".swiper-button-next").addClass("pdp-fit-cards-btn-next-" + index);

        // Generate unique btn classes for slider swiper
        $this.parents('.fit-cards').find(".swiper-scrollbar").addClass("pdp-fit-cards-swiper-scrollbar-" + index);


        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".pdp-fit-cards-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
            slidesPerView: 1.6,
            spaceBetween: 38,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            keyboard: {
                enabled: false
            },

            breakpoints: {
                // when window width is >= 680px
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 48
                }
            },

            // Navigation scrollbar
            scrollbar: {
                el: ".pdp-fit-cards-swiper-scrollbar-" + index,
                draggable: true,
            }
        });
    });
});

//Change Collection Template Structure on Resize
const collectionWrapper = document.querySelector(".collection-wrapper");
const collectionTemplate = document.querySelector(".page-section--collection-filter");
let fitCardsCollection = document.querySelector("#shopify-section-fit-cards--collection");

if (fitCardsCollection) {
    $(window).on('load resize', function() {
        fitCardsCollection = document.querySelector("#shopify-section-fit-cards--collection");
        if ($(window).width() >= 1024) {
            collectionWrapper.prepend(fitCardsCollection);
        } else {
            collectionTemplate.prepend(fitCardsCollection);
        }
    })
}